import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

import VueRouter from 'vue-router';
import Vuex from 'vuex';
import storeObj from './store.js';
import router from './router.js';
import VueCookies from 'vue-cookies'
import axios from 'axios'

import Util from '@/modules/util';
import "@/assets/global.css"
import initFilters from '@/Filters'
import CKEditor from 'ckeditor4-vue';

// window.isScreenActive = true;

Vue.prototype.$Util = Util;

console.log(process.env);

import GlobalRouter from './GlobalRouter.js';
import GlobalStore from './GlobalStore.js';
import CommonApiCall from './modules/CommonApiCall.js';
import ResponseCode from "./ResponseCode";


Vue.use(Vuex);
const store = new Vuex.Store(storeObj);

Vue.use( CKEditor );
Vue.use(VueRouter);
Vue.use(VueCookies);


let apiPath = "";
let resourcePath = '';
let branchUploadPath = '';
if(process.env.NODE_ENV === 'production'){
  apiPath = "/";
  resourcePath = '';
  branchUploadPath = '/uploads/images/branch/';
}else if(process.env.NODE_ENV === 'development'){
  axios.defaults.baseURL = process.env.VUE_APP_TEST_URL + "/";
  apiPath = axios.defaults.baseURL;
  resourcePath = axios.defaults.baseURL;
  // resourcePath = 'http://obyungear-user.ubiplus.co.kr';
  // branchUploadPath = 'uploads/images/branch/';
  // Vue.$cookies.set('device', 'android');
  // Vue.$cookies.set('device', 'ios');
  Vue.$cookies.set('device', 'pc');

}
Vue.prototype.$apiPath = apiPath;
Vue.prototype.$resourcePath = resourcePath;
Vue.prototype.$branchUploadPath = branchUploadPath;

GlobalRouter.init(router);
GlobalStore.init(store);
Vue.prototype.$GlobalRouter = GlobalRouter;
Vue.prototype.$GlobalStore = GlobalStore;
Vue.prototype.$Axios = CommonApiCall;
Vue.prototype.$Once = (fn) => {
  let done = false;
  return async (...args) => {
    if (!done) {
      done = true;
      try{
        const result = await fn(...args);
          done = false;
        return result;
      }catch (e) {
          done = false;
          console.error(e);
      }

    }else {
      GlobalStore.showAlert('처리중입니다. 잠시만 기다려주세요.');
    }
  }
};


Vue.prototype.$hasOwnProperty = function(data, key){
    return Object.prototype.hasOwnProperty.call(data, key);
};

initFilters();

window.copyObject = function(obj){
  return JSON.parse(JSON.stringify(obj));
};

window.copyToClipboard = function(copyStr){
  var body = document.querySelector('body');
  var textArea = document.createElement("textarea");
  textArea.value = copyStr;
  body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  body.removeChild(textArea);
  store.commit('showToast', '복사되었습니다.');
};

window.goBack = function(){
    const modalLength = store.getters.modalLength
  if(modalLength === 0){
      if(store.state.pagePopFlags.length > 0){
          store.commit('closeLastPop', true);
          return;
      }

      if(location.pathname !== '/view/home'){
          GlobalRouter.push('/view/home?' + new Date().getTime());
          return;
      }

      var device = Vue.$cookies.get('device');
      if(device === 'android'){
        window.Android.closeApp();
      }
  } else {
      const lastModal = store.state.modals[modalLength - 1];
      // alert('실행' + JSON.stringify(store.state.modals.length));
      if(lastModal.popFlags && lastModal.popFlags.length > 0){
            store.commit('closeLastPop', true);
      }else {
          store.commit('closeLastModal');
      }

  }
};

axios.interceptors.request.use(function (config) {
  // store.commit('showProgress');
  config.metadata = { startTime: new Date()}
  return config;
}, function (error) {
  // store.commit('hideProgress');
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
    if(response.data.code === ResponseCode.LOGIN_INVALID){
        GlobalStore.showAlert(response.data.msg);
        // GlobalStore.showSystemPatch();
        // setTimeout(() => {
        location.href = '/view/home';
        //     GlobalStore.hideSystemPatch();
        // }, 3000);
    } else if(response.data.code === ResponseCode.VERSION_CHANGED && process.env.NODE_ENV === 'production'){
        location.reload();
    }

    response.config.metadata.endTime = new Date()
    response.duration = response.config.metadata.endTime - response.config.metadata.startTime
    return response;
}, function (error) {
  GlobalStore.showToast('네트워크 오류가 발생했습니다.');
  // store.commit('hideProgress');
  return Promise.reject(error);
});

window.addEventListener('message', async function(e){
    var req = e.data;
    if(req.type === 'alreadyRegisted'){
        GlobalStore.closeLastModal(true);
        GlobalStore.closeLastModal(true);
        const res = await axios.get('/api/default');
        GlobalStore.setLoginInfo(res.data.loginInfo);
        await Util.checkAfterLogin();
        GlobalRouter.push('/view/home?' + new Date().getTime());
    }else if(req.type === 'goRegist'){
        GlobalStore.closeLastModal();
        GlobalStore.addModal('MemberRegister', {id : req.id, mode : req.loginPlatform});
    }
});

// window.completeWebbrowser = function(url){
//     const param = new URLSearchParams(url.split('?')[1]);
//     const type = param.get('type');
//     const data = param.get('data');
//     const code = param.get('code');
//     window.postMessage({type : type, code : code, data : data});
// }

window.loginSocialIOS = function(url){
    const param = new URLSearchParams(url.split('?')[1]);
    const type = param.get('type');

    const id = param.get('id');
    const loginPlatform = param.get('loginPlatform');
    window.postMessage({type : type, id : id, loginPlatform : loginPlatform});
}

axios.defaults.headers.common = {
  // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
  'X-Requested-With': 'XMLHttpRequest'
};

axios.defaults.withCredentials = true;

window.addEventListener('message', async function(e){
    const req = e.data;
    if(req.type === 'show_more'){
        GlobalStore.addModal('AgreementText', {transitionName : '', mode : parseInt(req.mode)})
    }
});


new Vue({
  store,
  router : router,
  render: h => h(App),
}).$mount('#app')
